import { render } from "./NewGroupForm.vue?vue&type=template&id=49f2d5ac"
import script from "./NewGroupForm.vue?vue&type=script&lang=js"
export * from "./NewGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__